import {
  BOTULINUM_FORM_ARCHIVED,
  BOTULINUM_FORM_FIELDS_SET_ARCHIVED,
  BOTULINUM_FORM_FIELDS_ARCHIVED,
  BOTULINUM_REQUIRED_FIELDS_ARCHIVED,
  BOTULINUM_FORM,
  BOTULINUM_FIELDS,
  BOTULINUM_FIELD_SET,
  BOTULINUM_REQUIRED_FIELDS,
  MIGRAINE_INJECTION_FORM,
  MIGRAINE_INJECTION_FORM_FIELD_SET,
  MIGRAINE_INJECTION_FORM_FIELDS,
  MIGRAINE_INJECTION_FORM_REQUIRED_FIELDS,
} from "./forms/botulinum";
import {
  DOI_FIELD_SET,
  DOI_FIELDS,
  DOI_FORM,
  DOI_REQUIRED_FIELDS,
} from "./forms/date-of-injury";
import {
  DIAGNOSES_FIELD_SET,
  DIAGNOSES_FIELDS,
  DIAGNOSES_FORM,
  DIAGNOSES_REQUIRED_FIELDS,
} from "./forms/diagnoses";
import {
  SCALENE_BLOCK_FIELDS,
  SCALENE_BLOCK_FIELDS_SET,
  SCALENE_BLOCK_FORM,
  SCALENE_BLOCK_REQUIRED_FIELDS,
} from "./forms/scalene-block";
import {
  UPPER_AND_LOWER_FORM,
  UPPER_AND_LOWER_FORM_FIELDS,
  UPPER_AND_LOWER_FORM_FIELDS_SET,
  UPPER_AND_LOWER_REQUIRED_FIELDS,
} from "./forms/upper-and-lower-injection";

export type FormConfiguration = {
  id: string;
  ids: Set<string>;
  fields: Record<string, string>;
  requiredFields: string[];
  isPersistent: boolean;
};

export const FORM_FIELDS: Record<string, FormConfiguration> = {
  [DIAGNOSES_FORM]: {
    id: DIAGNOSES_FORM,
    ids: DIAGNOSES_FIELD_SET,
    fields: DIAGNOSES_FIELDS,
    requiredFields: DIAGNOSES_REQUIRED_FIELDS,
    isPersistent: true,
  },
  [DOI_FORM]: {
    id: DOI_FORM,
    ids: DOI_FIELD_SET,
    fields: DOI_FIELDS,
    requiredFields: DOI_REQUIRED_FIELDS,
    isPersistent: true,
  },
  [UPPER_AND_LOWER_FORM]: {
    id: UPPER_AND_LOWER_FORM,
    ids: UPPER_AND_LOWER_FORM_FIELDS_SET,
    fields: UPPER_AND_LOWER_FORM_FIELDS,
    requiredFields: UPPER_AND_LOWER_REQUIRED_FIELDS,
    isPersistent: false,
  },
  [BOTULINUM_FORM]: {
    id: BOTULINUM_FORM,
    ids: BOTULINUM_FIELD_SET,
    fields: BOTULINUM_FIELDS,
    requiredFields: BOTULINUM_REQUIRED_FIELDS,
    isPersistent: false,
  },
  [MIGRAINE_INJECTION_FORM]: {
    id: MIGRAINE_INJECTION_FORM,
    ids: MIGRAINE_INJECTION_FORM_FIELD_SET,
    fields: MIGRAINE_INJECTION_FORM_FIELDS,
    requiredFields: MIGRAINE_INJECTION_FORM_REQUIRED_FIELDS,
    isPersistent: false,
  },
  [BOTULINUM_FORM_ARCHIVED]: {
    id: BOTULINUM_FORM_ARCHIVED,
    ids: BOTULINUM_FORM_FIELDS_SET_ARCHIVED,
    fields: BOTULINUM_FORM_FIELDS_ARCHIVED,
    requiredFields: BOTULINUM_REQUIRED_FIELDS_ARCHIVED,
    isPersistent: false,
  },
  [SCALENE_BLOCK_FORM]: {
    id: SCALENE_BLOCK_FORM,
    ids: SCALENE_BLOCK_FIELDS_SET,
    fields: SCALENE_BLOCK_FIELDS,
    requiredFields: SCALENE_BLOCK_REQUIRED_FIELDS,
    isPersistent: false,
  },
};
